/**
 * 短段时间轴
 * 以1s=1000ms为一个短段
 */
var ShortSegLine = /** @class */ (function () {
    function ShortSegLine() {
        this.list = [];
    }
    /** 添加一条弹幕 */
    ShortSegLine.prototype.add = function (dan) {
        var s = Math.floor(dan.start / 1000); // 获取开始时所在的秒段
        this.listAdd(s, dan); // 将弹幕添加进对应的秒段中
    };
    /** 删除一条弹幕 */
    ShortSegLine.prototype.remove = function (dan) {
        var _a, _b;
        var s = Math.floor(dan.start / 1000); // 获取开始时所在的秒段
        var i = (_a = this.list[s]) === null || _a === void 0 ? void 0 : _a.indexOf(dan); // 在该秒段内查找弹幕位置并删除
        i && i != -1 && ((_b = this.list[s]) === null || _b === void 0 ? void 0 : _b.splice(i, 1));
    };
    /** 获取一个分段的弹幕 */
    ShortSegLine.prototype.getSegList = function (i) {
        return this.listGet(i);
    };
    /** 清空时间轴 */
    ShortSegLine.prototype.clear = function () {
        this.list = [];
    };
    ShortSegLine.prototype.listAdd = function (i, item) {
        if (!this.list[i]) {
            this.list[i] = [];
        }
        this.list[i].push(item);
    };
    ShortSegLine.prototype.listGet = function (i) {
        return this.list[i] || [];
    };
    return ShortSegLine;
}());
export { ShortSegLine };
//# sourceMappingURL=ShortSegLine.js.map